import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface WarehouseBreadcrumbProps {
  warehouseName?: string;
}

export const WarehouseBreadcrumb = ({ warehouseName }: WarehouseBreadcrumbProps) => {
  const { t } = useTranslation('warehouseMapModule');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    return [{ label: t('warehouses.title', 'Warehouses'), path: '/warehouses' }, { label: warehouseName || '' }];
  }, [t, warehouseName]);

  usePageNavigation({ breadcrumbs });

  return null;
};
